// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"61625c8895dbb901","src_app_auth_auth_module_ts":"93393558c918ddb0","src_app_dashboard_dashboard_module_ts":"e2e50450ee4e35f4","src_app_admin_admin_module_ts":"a2a3bd1c9726c958","src_app_pages_pages_module_ts":"80a6b5b3e6bffc46"}[chunkId] + ".js";
};